import { getRealtimeEventSource } from 'utils/realtimeEventSource';

const RealtimeSourceLabel = ({ item, iconOnly = false, className = '' }) => {
  const { value, name } = getRealtimeEventSource(item);
  return iconOnly ? (
    <span
      className={`realtime-source-label icon-only ${value} ${className}`}
      role='img'
      aria-label={name}
      title={name}
    />
  ) : (
    <span className={`realtime-source-label ${value} nowrap-item ${className}`}>{name}</span>
  );
};

export default RealtimeSourceLabel;
